export enum VtmnPlayIconButtonVariantEnum {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  NEGATIVE = 'negative',
  CAMOUFLAGE = 'camouflage',
}
